import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"



import DefaultInput from '../components/DefaultInput.vue';
import DefaultInputNumber from '../components/DefaultInputNumber.vue';
import MetricInput from '../components/MetricInput.vue';
import DefaultToggleSwitch from '../components/DefaultToggleSwitch.vue';
import ItemLabel from '../components/ItemLabel.vue';

import type { ValueItem } from '../utils/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ItemValueInput',
  props: {
    item: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.item.value_type === 'string' && !_ctx.item.value_unit)
    ? (_openBlock(), _createBlock(DefaultInput, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(ItemLabel, { item: _ctx.item }, null, 8, ["item"])
        ]),
        _: 1
      }))
    : (_ctx.item.value_type === 'string' && _ctx.item.value_unit)
      ? (_openBlock(), _createBlock(MetricInput, {
          key: 1,
          type: "string"
        }, {
          label: _withCtx(() => [
            _createVNode(ItemLabel, { item: _ctx.item }, null, 8, ["item"])
          ]),
          metric: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.item.value_unit), 1)
          ]),
          _: 1
        }))
      : (_ctx.item.value_type === 'integer' && !_ctx.item.value_unit)
        ? (_openBlock(), _createBlock(DefaultInputNumber, { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(ItemLabel, { item: _ctx.item }, null, 8, ["item"])
            ]),
            _: 1
          }))
        : (_ctx.item.value_type === 'integer' && _ctx.item.value_unit)
          ? (_openBlock(), _createBlock(MetricInput, {
              key: 3,
              type: "number"
            }, {
              label: _withCtx(() => [
                _createVNode(ItemLabel, { item: _ctx.item }, null, 8, ["item"])
              ]),
              metric: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.item.value_unit), 1)
              ]),
              _: 1
            }))
          : (_ctx.item.value_type === 'float' && !_ctx.item.value_unit)
            ? (_openBlock(), _createBlock(DefaultInputNumber, {
                key: 4,
                minFractionDigits: 2,
                maxFractionDigits: 2
              }, {
                default: _withCtx(() => [
                  _createVNode(ItemLabel, { item: _ctx.item }, null, 8, ["item"])
                ]),
                _: 1
              }))
            : (_ctx.item.value_type === 'float' && _ctx.item.value_unit)
              ? (_openBlock(), _createBlock(MetricInput, {
                  key: 5,
                  type: "number",
                  minFractionDigits: 2,
                  maxFractionDigits: 2
                }, {
                  label: _withCtx(() => [
                    _createVNode(ItemLabel, { item: _ctx.item }, null, 8, ["item"])
                  ]),
                  metric: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.item.value_unit), 1)
                  ]),
                  _: 1
                }))
              : (_ctx.item.value_type === 'boolean')
                ? (_openBlock(), _createBlock(DefaultToggleSwitch, { key: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(ItemLabel, { item: _ctx.item }, null, 8, ["item"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
}
}

})